import styles from './empty-state.module.css';

type EmptyStateProps = {
  title: string;
  description?: string;
};

export const EmptyState = ({ title, description }: EmptyStateProps) => (
  <div className={styles.emptyState}>
    <p className={styles.title}>{title}</p>
    {description !== undefined && <p className={styles.description}>{description}</p>}
  </div>
);
